<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "SalesMainPage"
};
</script>

<style></style>
